import { Box, Button, Input, Stack, Text } from "@chakra-ui/react";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import FormLabelWithInfoTooltip from "../Widgets/FormLabelWithInfoTooltip";

// Brand-facing social handles only. Support URLs (docs / Discord) and
// the agency contact email live in their own forms — they're related
// but conceptually different concerns.
const Social = ({ brandingForm, getAgencies }) => {
  const baseUrl = getHostDomain();
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit } = brandingForm;
  const agency = useContext(AgencyContext);
  const { agencyData, buttonColorScheme, staffRole } = agency;
  const canWrite = !staffRole || staffRole === "admin";

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await fetchController(
        baseUrl + `/api/v1/agency/${agencyData.id}`,
        "PUT",
        data
      );
      getAgencies();
      toast.success("Social profiles updated");
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(onSubmit)();
      }}
    >
      <Stack direction="column" spacing={4} mb={4} maxW="520px">
        <Text fontSize="sm" color="gray.500">
          Your public social profiles. Surfaced in the subaccount
          portal footer where relevant.
        </Text>
        <Box>
          <FormLabelWithInfoTooltip label="Twitter / X" />
          <Input
            type="url"
            placeholder="https://x.com/your-handle"
            {...register("branding.socials.twitter")}
          />
        </Box>
        <Box>
          <FormLabelWithInfoTooltip label="Facebook" />
          <Input
            type="url"
            placeholder="https://facebook.com/your-page"
            {...register("branding.socials.facebook")}
          />
        </Box>
        <Box>
          <FormLabelWithInfoTooltip label="LinkedIn" />
          <Input
            type="url"
            placeholder="https://linkedin.com/company/..."
            {...register("branding.socials.linkedin")}
          />
        </Box>
        <Box>
          <FormLabelWithInfoTooltip label="Instagram" />
          <Input
            type="url"
            placeholder="https://instagram.com/..."
            {...register("branding.socials.instagram")}
          />
        </Box>
      </Stack>
      <Button
        isLoading={isLoading}
        colorScheme={buttonColorScheme}
        type="button"
        onClick={() => handleSubmit(onSubmit)()}
        isDisabled={!agencyData || !canWrite}
      >
        Save
      </Button>
    </form>
  );
};

export default Social;
